// export const baseURL = "http://localhost:8080";
//export const baseURL = "https://vt-backend.vercel.app";
//
// Env-overridable so a local FE can target a local sandbox VT-BE
// (set REACT_APP_API_BASE_URL=http://localhost:8080 in .env.local).
export const baseURL = process.env.REACT_APP_API_BASE_URL || "https://backend.villatracker.com";
export const guestyBaseURL = "http://channel-manager.guesty.yieldplanet.com";